<template>
  <div class="modal contact-modal ready-modal">
    <div class="overlay" @click="closeReadyModal"></div>
    <div class="wrapper">
      <img class="close" @click="closeReadyModal" src="./../images/close.svg"/>
      <div class="container">
        <div>
          <div class="form-wrapper">
            <div class="form-fields" v-if="!successMessage">
              <div class="title">{{ $t(`Are you sure?`) }}</div>
              <div class="price title">TOTAL: {{ modifiedPrice }} {{ internalCurrencyName }}</div>
              <button class="button" @click="handlePurchase" :disabled="isLoading">
                <span v-if="!isLoading">{{ $t(`Buy`) }}</span>
                <span v-else class="loading-spinner"></span>
              </button>
              <transition name="fade">
                <div class="desc error-desc red" v-if="error">{{ error }}</div>
              </transition>
            </div>
            <transition name="fade">
              <div class="form-fields" v-if="successMessage">
                <div class="title error-desc green">{{ successMessage }}</div>
                <button class="button" @click="closeReadyModal">
                  <span>{{ $t(`Ok`) }}</span>
                </button>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {defineComponent} from 'vue';

export default defineComponent({
  name: 'ReadyModal',
  props: [],
  inject: [
    'closeReadyModal',
    'internalCurrencyName',
    'closeReadyModal',
    'successMessage',
    'error',
    'readyPack',
    'readyPromt',
    'activePack',
    'readyProduct',
    'productPageItem',
    'productPageType',
      'buyProduct',
      'buyPack'
  ],

  components: {},

  data: function () {
    return {
      activePack: '',
      modifiedPrice: '',
      isLoading: false
    }
  },

  mounted() {
    this.setPrice();
    this.getActivePack();
  },

  methods: {
    setPrice() {
      if (this.readyProduct) {
        if (this.readyPromt) {
          this.modifiedPrice = this.readyProduct.price;
        } else if (this.readyPack) {
          this.modifiedPrice = this.activePack?.price || this.readyProduct.price;
        }
      } else if (this.productPageItem) {
        if (this.readyPromt) {
          this.modifiedPrice = this.productPageItem.price;
        } else if (this.readyPack) {
          this.modifiedPrice = this.activePack?.price || this.productPageItem.price;
        }
      }
    },
    getActivePack() {
      if (this.productPageItem && this.productPageItem.pack_id && this.productPageType != 'prompt') {
        console.log('pack page');
        this.$http.get('packs/' + this.productPageItem.pack_id + '/info')
            .then((res) => {
              this.activePack = res.data.payload
              this.modifiedPrice = res.data.payload.price
            })
            .catch(() => {

            })
      } else {
        console.log('prompt page');
        // For prompt pages, set the price directly
        if (this.productPageItem && this.productPageItem.price) {
          this.modifiedPrice = this.productPageItem.price;
        }
      }
    },
    handlePurchase() {
      this.isLoading = true;
      if (this.productPageItem && this.productPageItem.pack_id && this.productPageType != 'prompt') {
        // For packs, pass the pack ID
        this.buyPack(this.productPageItem.id);
      } else {
        if (this.readyPack || (this.readyProduct && this.readyProduct.product_type === 'pack')) {
          // For packs, pass the pack ID
          const packId = this.readyProduct?.id || this.productPageItem?.id;
          this.buyPack(packId);
        } else if (this.readyPromt && this.productPageItem) {
          // Call the injected buyProduct function for prompts
          this.buyProduct(this.productPageItem.id);
        }
      }
    }
  },
});
</script>

<style scoped>
.loading-spinner {
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: #fff;
  animation: spin 1s ease-in-out infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}
</style>